import axios, {AxiosRequestConfig} from 'axios'
import { Util } from '@/_global/utils'
import {CmsApiClient} from "@/_global/api_clients/CmsApiClient";
import GenerationsStore from "@/store/modules/GenerationsStore";
import ApiLogsStore from "@/store/modules/ApiLogsStore";

const resourceName = Util.getUrlParam("head_id");
const host: string = Util.getDeliousHostUrl() + resourceName + "/apisessionful/common/v1/";


function makeConfig(): AxiosRequestConfig {
    return {
        withCredentials: true,
        params: {
            system_name: "nsketch_next_lio",
        }
    }
}

export class DeliousApiClientProd {

    public static async getUser() {
        const url = host + "session/getuser";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || {};
    }

    public static async getItemSearchList(storeId: number, generationId: number) {
        const url = host + "/plu/getlist?storecode=" + storeId + "&period_no=" + generationId;
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || {list: []};
    }

    public static async getStores() {
        const url = host + "store/getlist";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || {list: []};
    }

    public static async getGenerations() {
        const url = host + "generation/getlist";
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || {list: []};
    }

    public static async getItemDetailList(storeId: number, periodId: number) {
        // CMS側の中継APIを経由させて取得する。
        return await CmsApiClient.getDeliousItemDetailList(storeId, periodId);
    }

    public static async getPluClassList(storeId: number, level: string) {
        const url = host + "pluclass/getlist?storecode=" + storeId + "&level=" + level;
        const response = await axios.get(url, makeConfig());
        ApiLogsStore.add(response);
        return response.data || {list: []};
    }
}

